import { EventEmitter } from 'events';

import util from '../tools/util';
import UserStore from './user_store';

export default {
  once,
  addChangeListener,
  removeChangeListener,
  init,
  isReady,
  getVolumeDirList,
  fetchVolumeDir,
  undelete,
  unlock,
  fetchReport,
};

let g_fileListMap: any = {};

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function once(callback) {
  g_eventEmitter.once(CHANGE_EVENT, callback);
}
function addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
function removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function init(done) {
  done && done();
}
function isReady() {
  return true;
}
function getVolumeDirList(volume_id: number, path: string) {
  const key = `${volume_id}-${path}`;
  return g_fileListMap[key];
}
function fetchVolumeDir(params: any, done?: any) {
  const { volume_id, path } = params;
  const opts = {
    url: `/api/1/file/dir`,
    query: {
      volume_id,
      prefix_path: path,
    },
  };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('FuseFileStore.fetchVolumeDir: err:', err, body);
    } else {
      const key = `${volume_id}-${path}`;
      g_fileListMap[key] = body;
      _emit('update_dir');
    }
    if (done) {
      done(err, body);
    }
  });
}
function undelete(params: any, done: (err: string | null) => void) {
  const { volume_id, file_id } = params;
  const opts = {
    url: `/api/1/file/${file_id}/undelete`,
    query: {
      volume_id,
    },
  };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog('FuseFileStore.undelete: err:', err, body);
    }
    done(err);
  });
}
function unlock(params: any, done: (err: string | null) => void) {
  const { volume_id, file_id } = params;
  const opts = {
    url: `/api/1/file/${file_id}/lock`,
    query: {
      volume_id,
    },
    body: {
      force_unlock: true,
    },
  };
  UserStore.del(opts, (err, body) => {
    if (err) {
      util.errorLog('FuseFileStore.undelete: err:', err, body);
    }
    done(err);
  });
}
function fetchReport(params: any, done: (err: any, report: any) => void) {
  const { volume_id, start_date } = params;
  const opts = {
    url: '/api/1/admin/file_report',
    query: {
      volume_id,
      start_date,
    },
  };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('FuseFileStore.fetchReport: err:', err, volume_id);
    }
    done(err, body && body.file_report_lines);
  });
}
